export default __webpack_public_path__ + "static/media/art-pro-brw-poster-3.3fe52e9c.jpg";